import * as React from "react";
import Svg, { Defs, Path, G, Mask, Use } from "react-native-svg";

function BackLeftArrow(props) {
  return (
    <Svg
      width={props.width || 29}
      height={props.height || 29}
      viewBox="0 0 29 29"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      {...props}
    >
      <Defs>
        <Path id="a" d="M0 0H29V29H0z" />
      </Defs>
      <G stroke="none" strokeWidth={1} fill="none" fillRule="evenodd">
        <Mask id="b" fill="#fff">
          <Use xlinkHref="#a" />
        </Mask>
        <G mask="url(#b)" fill={props.color || "#707070"} fillRule="nonzero">
          <Path
            transform="rotate(180 14.5 14.5)"
            d="M14.5 0L11.8628125 2.6371875 21.8424375 12.6168125 0 12.6168125 0 16.3831875 21.84425 16.3831875 11.8628125 26.3628125 14.5 29 29 14.5z"
          />
        </G>
      </G>
    </Svg>
  );
}

export default BackLeftArrow;
